<template>
  <submitted-successfully-view>
    <template #panel-body> Your reply has been sent to the practice. </template>

    <!-- The shared default slot is request-flow copy ("if you don't hear back within a week",
         response times). A reply needs the emergency guidance but none of that. -->
    <template #default>
      <p class="mpf-heading-s">If your message is urgent or you're not sure:</p>
      <ul>
        <li v-if="tenant?.localOrganisation.phone">
          call the surgery on
          <a :href="`tel:${tenant?.localOrganisation.phone}`" class="mpf-link">{{
            tenant?.localOrganisation.phone
          }}</a>
        </li>
        <li v-if="isNhsJurisdiction">
          if the surgery is closed, phone 111 or go to
          <a href="https://111.nhs.uk/" target="_blank" rel="noopener noreferrer" class="mpf-link"
            >NHS 111 online</a
          >
        </li>
        <li>in an emergency, phone 999 or go to A&amp;E</li>
      </ul>
    </template>
  </submitted-successfully-view>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia';
  import SubmittedSuccessfullyView from './SubmittedSuccessfullyView.vue';
  import { useTenantStore } from '@/stores/useTenantStore';

  const { tenant, isNhsJurisdiction } = storeToRefs(useTenantStore());
</script>
